import { render, staticRenderFns } from "./Detailtickets.vue?vue&type=template&id=3fc36a9c"
import script from "./Detailtickets.vue?vue&type=script&lang=js"
export * from "./Detailtickets.vue?vue&type=script&lang=js"
import style0 from "./Detailtickets.vue?vue&type=style&index=0&id=3fc36a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports